module.exports = __webpack_public_path__ + "media/images/receipt-template-standard-461c7d831ae4a392746f3b2860741fd2.png";